import { PasswordPolicyType } from 'aws-sdk/clients/cognitoidentityserviceprovider';
import { PoolDto } from './PoolDto';

export class UserPoolInfo {
  isRegistrationEnabled: boolean;
  passwordPolicy: PasswordPolicyType;
  pool: PoolDto;
}

